<div>
  <mat-dialog-content>
    <tr>
      <p> Debido a un tema de seguridad, deberá volver a iniciar sesión. Espere unos segundos
      </p>
    </tr>
  </mat-dialog-content>
</div>
